exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-link[data-v-055f786c] {\r\n  margin-right: 20px;\r\n  display: flex;\r\n  align-items: center;\n}\n.app-link.black[data-v-055f786c] {\r\n  filter: drop-shadow(0px 0px 5px #39c0ee);\n}\r\n", ""]);

// exports
